import { Routes, UrlSegment } from '@angular/router';
export function homeUrl(url) {
    return url.length > 0 && url[url.length - 1].path === 'home' ? ({ consumed: url }) : null;
}
const ɵ0 = () => import("./modules/pension-outlook/pension-outlook.module.ngfactory").then(m => m.PensionOutlookModuleNgFactory);
const routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        matcher: homeUrl,
        loadChildren: ɵ0
    }
];
export class AppRoutingModule {
}
export { ɵ0 };
